'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../tslib.es6-130a177d.js');
var React = require('react');
var styled = require('styled-components');
var Picture_Image_index = require('./Image/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var _a;
(function (ImageFormat) {
    ImageFormat["GIF"] = "gif";
    ImageFormat["GIF_FF"] = "gif_ff";
    ImageFormat["JPEG"] = "jpeg";
    ImageFormat["NONE"] = "";
    ImageFormat["PNG"] = "png";
    ImageFormat["SVG"] = "svg";
    ImageFormat["WEBP"] = "webp";
})(exports.ImageFormat || (exports.ImageFormat = {}));
var mimeTypes = (_a = {},
    _a[exports.ImageFormat.GIF] = 'image/gif',
    _a[exports.ImageFormat.GIF_FF] = 'image/gif',
    _a[exports.ImageFormat.JPEG] = 'image/jpeg',
    _a[exports.ImageFormat.NONE] = 'image/jpeg',
    _a[exports.ImageFormat.PNG] = 'image/png',
    _a[exports.ImageFormat.SVG] = 'image/svg+xml',
    _a[exports.ImageFormat.WEBP] = 'image/webp',
    _a);
var Sources = function (_a) {
    var sources = _a.sources;
    var sourcesWithSrcSets = sources.map(function (source) { return (tslib_es6.__assign(tslib_es6.__assign({}, source), { srcSet: source.url + " " + source.value + "x", sortKey: source.format + "--" + source.media })); });
    sourcesWithSrcSets.sort(function (a, b) { return (a.sortKey > b.sortKey ? 1 : -1); });
    sourcesWithSrcSets.reverse();
    var finalSources = sourcesWithSrcSets.reduce(function (acc, source) {
        if (acc.length > 0 && acc[acc.length - 1].sortKey === source.sortKey) {
            acc[acc.length - 1].srcSet += ", " + source.srcSet;
            return acc;
        }
        acc.push(source);
        return acc;
    }, []);
    return (React__default['default'].createElement(React__default['default'].Fragment, null, finalSources.map(function (source) { return (React__default['default'].createElement("source", { key: source.url + source.format + source.media, srcSet: source.srcSet, type: mimeTypes[source.format], media: source.media, sizes: source.sizes })); })));
};
var StyledPicture = styled__default['default'].picture.withConfig({ displayName: "ww-uikit_StyledPicture_m1yqix04", componentId: "sc-ju3sx8" })(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    display: flex;\n    ", "\n    ", "\n"], ["\n    display: flex;\n    ", "\n    ", "\n"])), function (_a) {
    var picHeight = _a.picHeight;
    return picHeight && "height: " + picHeight + "px;";
}, function (_a) {
    var picWidth = _a.picWidth;
    return picWidth && "width: " + picWidth + "px;";
});
var Picture = React.forwardRef(function (_a, ref) {
    var className = _a.className, fallback = _a.fallback, loading = _a.loading, objectFit = _a.objectFit, objectPosition = _a.objectPosition, picHeight = _a.picHeight, picWidth = _a.picWidth, sources = _a.sources, testId = _a.testId, errorFunction = _a.errorFunction, loadFunction = _a.loadFunction;
    var isValidSourceElement = function (sourcesProps) {
        return !!React__default['default'].isValidElement(sources);
    };
    return (React__default['default'].createElement(StyledPicture, { ref: ref, "data-testid": testId, className: className, picHeight: picHeight, picWidth: picWidth },
        isValidSourceElement() ? sources : React__default['default'].createElement(Sources, { sources: sources }),
        React__default['default'].createElement(Picture_Image_index['default'], { className: fallback.className, loading: loading, objectFit: objectFit, objectPosition: objectPosition, url: fallback.url, alt: fallback.alt, onError: errorFunction, onLoad: loadFunction })));
});
Picture.displayName = 'Picture';
var jpegBackupSource = function (source, url) { return [
    source,
    tslib_es6.__assign(tslib_es6.__assign({}, source), { url: url, format: exports.ImageFormat.JPEG }),
]; };
var templateObject_1;

exports.default = Picture;
exports.jpegBackupSource = jpegBackupSource;
//# sourceMappingURL=index.js.map
